import { useParams } from 'react-router';
import { useUser } from '../Context/useUser';

// Whose dashboard is this? The route param when a Coach/Admin is visiting someone
// (/athlete/:athleteId, /coach/:coachId), else the signed-in user. The id from the URL is only a
// request: the API still authorises it server-side.
const PARAM = { athlete: 'athleteId', coach: 'coachId' };

const useDashboardSubject = role => {
    const { user } = useUser();
    const params = useParams();
    const visited = params[PARAM[role]];
    return { id: visited || user?._id, isVisit: Boolean(visited) };
};

export default useDashboardSubject;
